export const siteMeta = {
  name: "独家吃瓜",
  slogan: "深扒内幕 · 复盘真相 · 还原完整时间线",
  intro:
    "我们把散落在各平台的碎片信息，按时间顺序重新拼成一条能读懂的线：先发生了什么事，各方什么时候回应，哪些细节对不上。不做人身攻击，不做未证实指控，只做公开信息的整理与逻辑梳理。",
  email: "hello@dujiachigua.media",
  wechat: "dujiachigua_media",
  city: "内容团队分布在北京与成都",
};

export const categories = [
  { slug: "all", name: "全部档案", desc: "所有已归档的事件复盘" },
  { slug: "industry", name: "娱乐圈动态", desc: "行业层面的变动与平台策略" },
  { slug: "variety", name: "综艺幕后", desc: "录制、剪辑与播出之间发生的偏差" },
  { slug: "brand", name: "商业代言", desc: "代言、合作与解约的时间线" },
  { slug: "live", name: "演出 Live", desc: "演唱会、音乐节的票务与公告" },
  { slug: "screen", name: "影视剧集", desc: "剧集制作、排播与宣发争议" },
];

export const events = [
  {
    slug: "film-recast",
    title: "剧组换角风波全复盘：从官宣到深夜通稿的三天",
    category: "影视剧集",
    categorySlug: "screen",
    date: "2026-09-08",
    readTime: "8 分钟",
    author: "档案组 · 阿岚",
    heat: 9860,
    excerpt:
      "一条官宣微博、一份凌晨发布的通稿、三版互相矛盾的路透，72 小时里信息被反复推翻。我们把每一版说法按发布时间排列，标出其中对不上的地方。",
    tags: ["换角风波", "时间线梳理", "官方通稿"],
    image:
      "https://readdy.ai/api/search-image?query=modern%20minimalist%20film%20studio%20with%20warm%20amber%20lights%20and%20dark%20crimson%20curtain%20background%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20editorial%20photography%20high%20detail&width=800&height=600&seq=gua-art-01&orientation=landscape",
  },
  {
    slug: "variety-editing",
    title: "综艺剪辑争议始末：一段未播花絮如何引爆热搜",
    category: "综艺幕后",
    categorySlug: "variety",
    date: "2026-09-06",
    readTime: "7 分钟",
    author: "档案组 · 老周",
    heat: 9240,
    excerpt:
      "同一场录制，正片和花絮呈现出两种完全不同的氛围。争议的关键不在谁说了什么，而在剪辑顺序把因果关系换了位置。",
    tags: ["剪辑争议", "录制花絮", "播出顺序"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20television%20broadcast%20studio%20with%20glowing%20screens%20and%20warm%20orange%20light%20reflections%2C%20dark%20moody%20background%2C%20no%20people%2C%20cinematic%20editorial%20photography&width=800&height=600&seq=gua-art-02&orientation=landscape",
  },
  {
    slug: "concert-ticketing",
    title: "演唱会票务疑云：加场公告背后的时间线",
    category: "演出 Live",
    categorySlug: "live",
    date: "2026-09-04",
    readTime: "6 分钟",
    author: "档案组 · 柚子",
    heat: 8910,
    excerpt:
      "首场售罄三小时后官宣加场，而加场票区的座位图与首场并不一致。我们对比了两版座位图，找出了三个被调整过的区块。",
    tags: ["票务", "加场公告", "座位图对比"],
    image:
      "https://readdy.ai/api/search-image?query=blurred%20concert%20hall%20with%20golden%20spotlights%20and%20distant%20crowd%20silhouettes%2C%20warm%20haze%2C%20no%20recognizable%20faces%2C%20cinematic%20photography%20high%20detail&width=800&height=600&seq=gua-art-03&orientation=landscape",
  },
  {
    slug: "brand-split",
    title: "代言解约事件复盘：品牌与工作室的 72 小时博弈",
    category: "商业代言",
    categorySlug: "brand",
    date: "2026-09-01",
    readTime: "9 分钟",
    author: "档案组 · 阿岚",
    heat: 8630,
    excerpt:
      "品牌在周五傍晚撤下物料，工作室在周日深夜发出声明，中间隔了整整两天。这两天里双方各自的动作，反而比声明本身更说明问题。",
    tags: ["代言解约", "声明对照", "合作周期"],
    image:
      "https://readdy.ai/api/search-image?query=dark%20wooden%20desk%20with%20contract%20documents%20and%20warm%20amber%20desk%20lamp%2C%20moody%20editorial%20still%20life%2C%20deep%20shadows%2C%20no%20people%20no%20readable%20text&width=800&height=600&seq=gua-art-04&orientation=landscape",
  },
  {
    slug: "festival-cancel",
    title: "音乐节临时取消：主办方公告与退票细则梳理",
    category: "演出 Live",
    categorySlug: "live",
    date: "2026-08-29",
    readTime: "5 分钟",
    author: "档案组 · 柚子",
    heat: 8120,
    excerpt:
      "开演前 22 小时宣布取消，公告只说了四个字「不可抗力」。真正让观众困惑的是退票规则的两处例外条款，我们逐条拆开来看。",
    tags: ["音乐节", "退票规则", "公告解读"],
    image:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20sunset%20with%20golden%20haze%20and%20empty%20field%2C%20dramatic%20warm%20sky%2C%20no%20people%2C%20cinematic%20photography&width=800&height=600&seq=gua-art-05&orientation=landscape",
  },
  {
    slug: "poster-billing",
    title: "影视番位之争：一张海报排版引发的连锁反应",
    category: "影视剧集",
    categorySlug: "screen",
    date: "2026-08-26",
    readTime: "6 分钟",
    author: "档案组 · 小林",
    heat: 7740,
    excerpt:
      "第一版海报按左中右排布，第二版改成了上下结构，第三版又加了一行小字说明。三次改动之间，只隔了 47 分钟。",
    tags: ["番位", "海报改版", "宣发口径"],
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20vintage%20printed%20posters%20on%20dark%20surface%20with%20warm%20spotlight%2C%20abstract%20graphic%20shapes%2C%20no%20readable%20text%2C%20editorial%20still%20life&width=800&height=600&seq=gua-art-06&orientation=landscape",
  },
  {
    slug: "remake-rights",
    title: "跨境翻拍版权拉锯：三家出品方声明的对照阅读",
    category: "影视剧集",
    categorySlug: "screen",
    date: "2026-08-22",
    readTime: "10 分钟",
    author: "档案组 · 老周",
    heat: 6980,
    excerpt:
      "三家出品方在两天内先后发声，都说自己拥有改编权利。把三份声明并排放在一起，会看到它们对「权利范围」的定义完全不同。",
    tags: ["版权", "翻拍", "声明对照"],
    image:
      "https://readdy.ai/api/search-image?query=international%20map%20and%20globe%20on%20dark%20wooden%20table%20with%20warm%20amber%20light%2C%20moody%20editorial%20still%20life%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gua-art-07&orientation=landscape",
  },
  {
    slug: "live-commerce",
    title: "直播带货争议复盘：从选品到售后的完整链路",
    category: "商业代言",
    categorySlug: "brand",
    date: "2026-08-19",
    readTime: "8 分钟",
    author: "档案组 · 小林",
    heat: 6510,
    excerpt:
      "争议集中在「谁负责质检」这一环。我们把选品、上架、讲解、售后四个环节各方的表态排出来，发现中间有一段责任是空着的。",
    tags: ["直播带货", "选品链路", "售后责任"],
    image:
      "https://readdy.ai/api/search-image?query=modern%20streaming%20setup%20with%20ring%20light%20and%20glowing%20screen%20in%20dark%20room%2C%20warm%20orange%20and%20teal%20accents%2C%20no%20people%2C%20editorial%20photography&width=800&height=600&seq=gua-art-08&orientation=landscape",
  },
  {
    slug: "fanclub-ledger",
    title: "粉丝后援会账目争议：公开明细里的三类疑问",
    category: "娱乐圈动态",
    categorySlug: "industry",
    date: "2026-08-15",
    readTime: "7 分钟",
    author: "档案组 · 柚子",
    heat: 6040,
    excerpt:
      "后援会公开了一份长达 12 页的账目明细，看起来相当透明。但仔细核对后，有三类支出只有总额、没有对应凭证说明。",
    tags: ["后援会", "账目公开", "明细核对"],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20marble%20desk%20with%20open%20ledger%20notebook%20and%20warm%20reading%20lamp%2C%20moody%20editorial%20still%20life%2C%20no%20readable%20text%2C%20no%20people&width=800&height=600&seq=gua-art-09&orientation=landscape",
  },
];

export const faqs = [
  {
    question: "独家吃瓜的内容来源是什么？",
    answer:
      "我们只整理已经公开发布过的信息，包括官方公告、节目正片、品牌与工作室的公开声明以及可查证的时间节点。所有引用都会标注大致出处，不采用无法核实的私信爆料。",
  },
  {
    question: "事件复盘一般多久更新一次？",
    answer:
      "以事件本身为准，而不是固定频率。当一件事出现新的公开回应或关键信息时，我们会在 24 小时内补进时间线，并在文末标注本次更新的内容。",
  },
  {
    question: "怎么判断一篇复盘的信息是否可靠？",
    answer:
      "重点看两处：一是时间线里的每个节点是否都能对应到公开出处，二是文中是否明确区分了「已知事实」和「存疑推测」。如果一篇内容把推测写成了结论，那它就不值得当作参考。",
  },
  {
    question: "可以投递线索吗？",
    answer:
      "可以。页面底部有线索投递入口，请尽量附上可公开查证的链接或时间点。对于无法核实的私下说法，我们不会直接采用，但会作为后续核对的方向。",
  },
  {
    question: "为什么有的争议没有后续结论？",
    answer:
      "因为现实里确实有很多事情没有公开结论。这种情况下我们不会替任何一方下判断，而是把「目前已知到哪一步」和「还缺什么信息」写清楚，让读者知道空白在哪里。",
  },
];

export const testimonials = [
  {
    name: "莫念",
    role: "追剧八年",
    text: "最舒服的一点是它不催着你站队。看完时间线，我自己就能判断哪句话站不住脚，这比直接给我一个结论有用多了。",
  },
  {
    name: "梁一苇",
    role: "传媒专业在读",
    text: "写课程作业的时候拿它当参照，因为它把「事实」和「推测」分得很清楚，引用的公开声明也都有出处。",
  },
  {
    name: "阿禾",
    role: "演出常客",
    text: "演唱会加场那篇的座位图对比是真的细，我按它梳理的思路去核对了自己那张票，一下就明白问题出在哪。",
  },
  {
    name: "老陈",
    role: "品牌方从业者",
    text: "代言解约那篇把 72 小时的动作顺序排出来了，从公关节奏的角度看，比声明原文信息量大得多。",
  },
];

export const stats = [
  { value: "180+", label: "已归档事件" },
  { value: "46", label: "被后续公开信息证实的时间线" },
  { value: "24h", label: "重大回应后的补充更新时效" },
  { value: "0", label: "未经核实的私人爆料采用数" },
];

export const hotTopics = [
  { slug: "film-recast", label: "剧组换角全复盘" },
  { slug: "concert-ticketing", label: "演唱会加场票务" },
  { slug: "variety-editing", label: "综艺剪辑顺序" },
  { slug: "brand-split", label: "代言解约 72 小时" },
  { slug: "poster-billing", label: "海报番位改版" },
  { slug: "festival-cancel", label: "音乐节退票细则" },
  { slug: "fanclub-ledger", label: "后援会账目核对" },
];